import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import HomePage from './components/HomePage';
import ProjectDetail from './components/ProjectDetail';
import Timeline from './components/Timeline';
import Bio from './components/Bio';
import RetroPage from './components/RetroPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/project/:id" element={<ProjectDetail />} />
            <Route path="/timeline" element={<Timeline />} />
            <Route path="/story" element={<Bio />} />
            <Route path="/retro" element={<RetroPage />} />
          </Routes>
        </motion.div>
      </div>
    </Router>
  );
}

export default App;
